import { BackNavProps } from "@/components/molecules/BackNav"
import { create } from "zustand"

type navigationBarStore = {
  isHelpSidebarOpen: boolean,
  toggleHelpSidebarOpen: () => void,
  setHelpSidebarOpen: (open: boolean) => void,
  breadCrumbs?: Omit<BackNavProps, 'className'> | undefined,
  setBreadCrumbs: (breadCrumbs: Omit<BackNavProps, 'className'>) => void
}

export const useNavigationBarStore = create<navigationBarStore>((set) => ({
  isHelpSidebarOpen: false,
  toggleHelpSidebarOpen: () => {
    set((state) => ({
      isHelpSidebarOpen: !state.isHelpSidebarOpen
    }))
  },
  setHelpSidebarOpen: (open) => {
    set(() => {
      return ({ isHelpSidebarOpen: open })
    })
  },
  breadCrumbs: undefined,
  setBreadCrumbs: (breadCrumbs) => {
    set(() => {
      return ({ breadCrumbs })
    })
  }
}))